import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type CustomSurfaceTreatmentsDto = ClientInferResponseBody<
  typeof contract.companySettings.customSurfaceTreatments
>;

export const fetchCustomSurfaceTreatments = async (
  id: string,
): Promise<CustomSurfaceTreatmentsDto | null> => {
  const response = await api.companySettings.customSurfaceTreatments.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
